var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaudspeaker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 154,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_1",
    fill: "black",
    ry: 39.3761,
    rx: 39.1963,
    cy: 95.7798,
    cx: 56.1462
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "white",
    d: "m50.8493,73.4312c-10.5936,2.5541 -15.7138,12.4159 -16.9498,17.0275l5.2968,1.0642c1.2713,-8.0881 8.2984,-11.8838 11.653,-12.7706l0,-5.3211z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "white",
    d: "m60.3836,119.193c11.2557,-2.705 16.6959,-13.147 18.0091,-18.03l-5.6279,-1.126c-1.3506,8.564 -8.8169,12.583 -12.3812,13.522l0,5.634z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "white",
    d: "m48.2009,64.9175c-15.2548,3.8312 -21.5403,16.8501 -22.7762,22.8807l4.2374,1.0642c3.8137,-12.3449 14.3014,-17.5596 19.0685,-18.6238l-0.5297,-5.3211z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "white",
    d: "m63.056,127.706c15.9482,-4.086 22.5195,-17.973 23.8116,-24.406l-4.4301,-1.135c-3.987,13.168 -14.9514,18.73 -19.9352,19.866l0.5537,5.675z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_6",
    fill: "white",
    ry: 9.57798,
    rx: 9.53425,
    cy: 95.7799,
    cx: 56.1462
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_7",
    fill: "black",
    ry: 4.25688,
    rx: 4.23744,
    cy: 18.0917,
    cx: 18.0092
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_8",
    fill: "black",
    ry: 4.25688,
    rx: 4.23744,
    cy: 135.156,
    cx: 18.0092
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_9",
    fill: "black",
    ry: 4.25688,
    rx: 4.23744,
    cy: 135.156,
    cx: 94.2831
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_10",
    fill: "black",
    ry: 4.25688,
    rx: 4.23744,
    cy: 18.0917,
    cx: 94.2831
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_11",
    fill: "black",
    ry: 12.7706,
    rx: 12.7123,
    cy: 31.9266,
    cx: 56.1462
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_12",
    fill: "white",
    ry: 4.25688,
    rx: 4.23744,
    cy: 31.9266,
    cx: 56.1461
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_13",
    strokeWidth: 5,
    stroke: "black",
    rx: 9.5,
    height: 148.248,
    width: 106.233,
    y: 2.5,
    x: 2.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaudspeaker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laudspeaker.a6780f25b4768c2978eb81c43180705c.svg";